import React from 'react';
import { toast } from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CryptoJS from 'crypto-js';
import { loginSliceValue } from '../redux/reducers/loginSlice';
import usePatientEnrollment from '../hooks/users/usePatientEnrollment';
import { calculateAge, inputPhoneMasking, returnOnlyNumber, unMasking, validateEmail, validateOnlyChacters, validatePassword, validatePhone } from '../utils/validators';

import { Carousel } from 'react-responsive-carousel';
import { Input, SelectBox } from '../components';
import CarouselItem from '../pageComponents/Login/CarouselItem';
import { Button, SimpleButton } from '../components/Modal';

import 'react-responsive-carousel/lib/styles/carousel.min.css'; 
import classes from '../styles/PatientEnrollment.module.css';
import AppoitnemntSVG from '../pageComponents/Login/AppoitnemntSVG';
import FormsSVG from '../pageComponents/Login/FormsSVG';
import ReportingSVG from '../pageComponents/Login/ReportingSVG';
import BillingSVG from '../pageComponents/Login/BillingSVG';

interface IenrollmentStates {
  fname: { value: string; error: string };
  lname: { value: string; error: string };
  email: { value: string; error: string };
  phone: { value: string; error: string };
  password: { value: string; error: string };
  dob: { value: string; error: string };
  gender: { value: string; error: string };
  pin: { value: string; error: string };
}

const PatientEnrollment = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  let data = search.replaceAll("'", '');
  const dataParams = new URLSearchParams(search);
  const link = dataParams.get('link');

  const [enrollmentStates, setEnrollmentStates] = React.useState<IenrollmentStates>({
    fname: { value: '', error: '' },
    lname: { value: '', error: '' },
    email: { value: '', error: '' },
    phone: { value: '', error: '' },
    password: { value: '', error: '' },
    dob: { value: '', error: '' },
    gender: { value: '', error: '' },
    pin: { value: '', error: '' },
  });

  const { loading, userDetails, error } = useSelector(loginSliceValue);
  const { enrollPatient } = usePatientEnrollment();

  React.useEffect(() => {
    if (link && process.env.REACT_APP_LOGIN_PASSWORD_SALT) {
      // const encryptedClinic = CryptoJS.AES.encrypt(JSON.stringify({ clinicID: '902488' }), process.env.REACT_APP_LOGIN_PASSWORD_SALT).toString();
      // console.log('ad', encryptedClinic);
      // /enrollment?link=U2FsdGVkX1/voPOcL/YC3kPs+I7TdWsw0cZPaJaLPWdZ5UCBzw96nN6yIqIHsKTz => FEMGEVITY PIN

      const newLink = link.replace(/ /g, '+');
      const decryptedId = CryptoJS.AES.decrypt(newLink, process.env.REACT_APP_LOGIN_PASSWORD_SALT);
      var decryptedData = decryptedId ? JSON.parse(decryptedId.toString(CryptoJS.enc.Utf8)) : '';
      // console.log(decryptedData);
      if (decryptedData.clinicID) setEnrollmentStates(prevVal => ({ ...prevVal, pin: { value: decryptedData.clinicID, error: '' } }));
    }
  }, [link]);

  React.useEffect(() => {
    if (error.status === 'fail') {
      toast.error(error.msg);
    }
  }, [error]);
  
  React.useEffect(() => {
    if (userDetails && userDetails.status === 'success') {
      toast.success(userDetails.message || 'Registration successful! Please log in.');
      navigate('/login');
    }
  }, [navigate, userDetails]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    // debugger;
    e.preventDefault();
    if (!validateOnlyChacters(enrollmentStates.fname.value)) {
      setEnrollmentStates(prevVal => ({ ...prevVal, fname: { ...prevVal.fname, error: 'Please enter your valid first name.' } }));
    } else if (!validateOnlyChacters(enrollmentStates.lname.value)) {
      setEnrollmentStates(prevVal => ({ ...prevVal, lname: { ...prevVal.lname, error: 'Please enter your valid last name.' } }));
    } else if (!validateEmail(enrollmentStates.email.value)) {
      setEnrollmentStates(prevVal => ({ ...prevVal, email: { ...prevVal.email, error: 'Please enter your valid email address.' } }));
    } else if (!validatePhone(unMasking(enrollmentStates.phone.value))) {
      setEnrollmentStates(prevVal => ({ ...prevVal, phone: { ...prevVal.phone, error: 'Please enter your valid phone number.' } }));
    } 
    // else if (!validatePassword(enrollmentStates.password.value)) {
    //   setEnrollmentStates(prevVal => ({
    //     ...prevVal,
    //     password: { ...prevVal.password, error: 'Password must have atleast 8 characters with one capital letter, number & a special character.' },
    //   }));
    // } 
    
    else if (!enrollmentStates.dob.value || calculateAge(enrollmentStates.dob.value) < 5) {
      setEnrollmentStates(prevVal => ({ ...prevVal, dob: { ...prevVal.dob, error: 'Your should be atleast 5 years of age.' } }));
    } else if (!enrollmentStates.gender.value) {
      setEnrollmentStates(prevVal => ({ ...prevVal, gender: { ...prevVal.gender, error: 'Please select your gender.' } }));
    } else if (!enrollmentStates.pin.value || !enrollmentStates.pin.value.trim() || enrollmentStates.pin.value.trim().length < 6) {
      setEnrollmentStates(prevVal => ({ ...prevVal, pin: { ...prevVal.pin, error: 'Please enter vilid clinic PIN.' } }));
    } else {
      const formData = {
        firstName: enrollmentStates.fname.value,
        lastName: enrollmentStates.lname.value,
        name: enrollmentStates.fname.value + ' ' + enrollmentStates.lname.value,
        email: enrollmentStates.email.value,
        phone: unMasking(enrollmentStates.phone.value),
        // password: enrollmentStates.password.value,
        dob: enrollmentStates.dob.value,
        gender: enrollmentStates.gender.value,
        clinicID: enrollmentStates.pin.value,
      };
      enrollPatient(formData);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.input_container}>
        <img src='assets/logo-new.png' alt='clinIQ™ Logo' className={classes.logo} />
        <div className={classes.container_content}>
          <h1 className={classes.container_heading}>
            Get Started Now! <span>Enter your email that is registered with your clinic to enroll here</span>
          </h1>

          <form className={classes.container_form} onSubmit={handleSubmit}>
            <div className='displayflex gap-1 alignStart'>
              <Input
                label='First Name*'
                placeholder='First Name'
                name='first-name'
                value={enrollmentStates.fname.value}
                onChange={e => setEnrollmentStates(prevVal => ({ ...prevVal, fname: { value: e.target.value.trim(), error: '' } }))}
                errorMessage={enrollmentStates.fname.error}
                icon='user'
                valid={validateOnlyChacters(enrollmentStates.fname.value)}
                containerStyle={{ width: '100%' }}
              />
              <Input
                label='Last Name*'
                placeholder='Last Name'
                name='last-name'
                value={enrollmentStates.lname.value}
                onChange={e => setEnrollmentStates(prevVal => ({ ...prevVal, lname: { value: e.target.value.trim(), error: '' } }))}
                errorMessage={enrollmentStates.lname.error}
                icon='user'
                valid={validateOnlyChacters(enrollmentStates.lname.value)}
                containerStyle={{ width: '100%' }}
              />
            </div>

            <div className='displayflex gap-1 alignStart'>
              <Input
                label='Email address*'
                placeholder='Email address'
                type='email'
                name='email'
                value={enrollmentStates.email.value}
                onChange={e => setEnrollmentStates(prevVal => ({ ...prevVal, email: { value: e.target.value.trim(), error: '' } }))}
                errorMessage={enrollmentStates.email.error}
                icon='email'
                valid={validateEmail(enrollmentStates.email.value)}
                containerStyle={{ width: '100%' }}
              />
              <Input
                label='Phone Number*'
                placeholder='Phone number'
                name='phone'
                value={enrollmentStates.phone.value}
                onChange={e => setEnrollmentStates(prevVal => ({ ...prevVal, phone: { value: inputPhoneMasking(e.target.value), error: '' } }))}
                errorMessage={enrollmentStates.phone.error}
                icon='mobile'
                valid={validatePhone(unMasking(enrollmentStates.phone.value))}
                containerStyle={{ width: '100%' }}
              />
            </div>

            <div className='displayflex gap-1 alignStart'>
            <SelectBox
                label='Gender*'
                name='gender'
                value={enrollmentStates.gender.value}
                onChange={e => setEnrollmentStates(prevVal => ({ ...prevVal, gender: { value: e.target.value, error: '' } }))}
                errorMessage={enrollmentStates.gender.error}
                valid={enrollmentStates.gender.value ? true : false}
                containerStyle={{ width: '100%' }}
              >
                <option value=''>Select your gender</option>
                <option value='male'>Male</option>
                <option value='female'>Female</option>
                <option value='other'>Other</option>
              </SelectBox>
              <Input
                label='Date of Birth*'
                placeholder='Phone number'
                type='date'
                name='dob'
                value={enrollmentStates.dob.value}
                onChange={e => {
                  setEnrollmentStates(prevVal => ({
                    ...prevVal,
                    dob: {
                      value: e.target.value,
                      error: calculateAge(e.target.value) < 5 ? 'Your should be atleast 5 years of age.' : '',
                    },
                  }));
                }}
                errorMessage={enrollmentStates.dob.error}
                icon='calendar'
                valid={enrollmentStates.dob.value ? true : false}
                containerStyle={{ width: '100%' }}
              />
            </div>

            <div className='displayflex gap-1 alignStart'>
             
              {!link ? (
                <Input
                  label='Clinic PIN*'
                  placeholder='Clinic PIN'
                  type='text'
                  name='pin'
                  value={enrollmentStates.pin.value}
                  onChange={e => setEnrollmentStates(prevVal => ({ ...prevVal, pin: { value: returnOnlyNumber(e.target.value.trim()), error: '' } }))}
                  errorMessage={enrollmentStates.pin.error}
                  icon='pin'
                  valid={enrollmentStates.pin.value.length >= 6}
                  containerStyle={{ width: '100%' }}
                />
              ) : null}
            </div>

            <Button
              label={loading ? 'Please wait...' : 'Register'}
              span={false}
              type='submit'
              submitButtonStyle={{ justifyContent: 'center', fontSize: '1.5rem' }}
              disabled={loading}
            />
            <SimpleButton type='button' label='Already have an account? Log in now' onClick={() => navigate('/login')} />
          </form>
        </div>

        <div className={classes.container_copyright}>
          <p>&copy; {new Date(Date.now()).getFullYear()} clinIQ™</p>
          <p>
            Powered By{' '}
            <a href='https://www.the-algo.com/' target='__blank'>
              The Algorithm
            </a>
          </p>
        </div>
      </div>
      <div className={classes.carousel_container}>
        <Carousel selectedItem={1} autoPlay={true} infiniteLoop showStatus={false} showThumbs={false} showArrows={false}>
          <CarouselItem title='Reporting' subTitle='Provides real-time insights into clinic performance. Offers customizable reports and dashboards.'>
            <ReportingSVG />
          </CarouselItem>

          <CarouselItem title='Appointment scheduling' subTitle='Appointment scheduling feature helps reduce wait times and improve patient satisfaction'>
            <AppoitnemntSVG />
          </CarouselItem>

          <CarouselItem title='Billing' subTitle='Designed for the staff and your patients Intuitive interface. Straight forward and efficient. Secure'>
            <BillingSVG />
          </CarouselItem>

          <CarouselItem title='Forms' subTitle='Easily configure forms for your clinic. Search through submitted forms'>
            <FormsSVG />
          </CarouselItem>
        </Carousel>
      </div>
    </div>
  );
};

export default PatientEnrollment;
